import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './providers';
import { AuthProvider } from '../auth/AuthContext';
import { ThemeProvider } from '../theme/ThemeContext';
import { ToastProvider, ToastViewport } from '../components/ui';
import { router } from './router';
import { DevDatabaseBanner } from '../components/DevDatabaseBanner';

export function App() {
  return (
    <AppProviders>
      <ToastProvider>
        <AuthProvider>
          <ThemeProvider>
            <DevDatabaseBanner />
            <RouterProvider router={router} />
          </ThemeProvider>
        </AuthProvider>
        <ToastViewport />
      </ToastProvider>
    </AppProviders>
  );
}
